import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import {
  AbsolutePositioned,
  BackgroundContainer
} from '../../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { DiagonalLine, HorizontalLine, VerticalLine } from '../../../../components/Layout/Line';
import {
  Screen,
  SplitScreen,
  SplitScreenContentHolder
} from '../../../../components/Layout/Screen';
import Logo from '../../../../components/Logo';
import Title, { Highlight, Subtext } from '../../../../components/Title';
import GifViewer from '../../../../components/GifViewer';

// Assets
import { brandColors, device, fonts } from '../../../../styles/variables';
import background from '../../../../assets/images/pages/bridging-the-gap/elderly-man.png';
import room1 from '../../../../assets/images/pages/bridging-the-gap/room1purple.png';

const OverlayBackground = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
  background: url(${background}) center no-repeat;
  background-size: cover;
  background-position: 10% center;
  opacity: 0.9;
  @media ${device.tablet} {
    background-position: center;
  }
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

const TitlePosition = styled.div`
  font-family: ${fonts.monterrat};
  margin: 154px 0 0 0;
  float: left;
`;

const ContentHolder = styled.div`
  position: relative;
  pointer-events: none;
  padding: 0;
  height: 100%;
  width: 100%;
  z-index: 2;

  .title {
    max-width: 676px;
  }

  .subtext {
    max-width: 430px;
    @media ${device.tablet} {
      max-width: 500px;
    }
  }
`;

const ImageHolder = styled.div`
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 50%;
  max-width: 640px;
  display: none;

  @media ${device.mobileL} {
    display: block;
  }
`;

const ImgPosition1 = styled.div`
  position: absolute;
  width: 70%;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
`;

const FeatureScreen = () => (
  <Screen background={brandColors.blue} className="larger-screen">
    <OverlayBackground />
    <BackgroundContainer className="background-container">
      <HorizontalLine />
      <VerticalLine />
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
    </BackgroundContainer>
    <ContentHolder>
      <Logo />
      <ContentContainer>
        <TitlePosition>
          <Title className="title" subtitle="case study" color={brandColors.white}>
            <Highlight>Bridging</Highlight> the gap
            <Subtext className="subtext">
              The Directorate of Optometric Continuing Education and Training (DOCET) asked us to
              create a learning resource for optometrists, focusing on the management of older
              patients with vision loss. The brief requested four dramatised case studies,
              punctuated with expert interviews.
            </Subtext>
          </Title>
        </TitlePosition>

        <ImageHolder className="image-holder">
          <ImgPosition1>
            <GifViewer imgSrc={room1} title="Bridging the gap" gifSrc={room1} />
          </ImgPosition1>
        </ImageHolder>
      </ContentContainer>
    </ContentHolder>
  </Screen>
);

export default connect()(FeatureScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/BridgingTheGap/screens/Feature.jsx